<template>
	<div class="view-toggle">
		<button class="jmiBtn orange" @click="handleToggle">
			<span :class="currentViewMode === 'card' ? 'fa-light fa-list' : 'fa-light fa-grid'"></span>
			{{ currentViewMode === 'card' ? 'Table View' : 'Card View' }}
		</button>
	</div>
</template>

<script>
export default {
	props: {
		viewMode: {
			type: String,
			default: 'table',
			validator: (value) => ['card', 'table'].includes(value)
		}
	},
	emits: ['toggle'],
	computed: {
		currentViewMode() {
			return this.viewMode || 'table'
		}
	},
	methods: {
		handleToggle() {
			this.$emit('toggle', this.currentViewMode === 'card' ? 'table' : 'card')
		}
	}
}
</script>
